import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdmin } from '../contexts/AdminContext';

const RequireAuth = ({ children }) => {
  const { isAuthenticated, loading } = useAdmin();
  const location = useLocation();
  const [isRedirecting, setIsRedirecting] = useState(false);

  // Yönlendirme döngüsünü önlemek için
  useEffect(() => {
    return () => {
      // Bileşen unmount olduğunda yönlendirme durumunu sıfırla
      setIsRedirecting(false);
    };
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-[#592c82]"></div>
      </div>
    );
  }

  if (!isAuthenticated && !isRedirecting) {
    setIsRedirecting(true);
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth; 